export default __webpack_public_path__ + "static/media/houimg5.c9f5358d.webp";